import { NgModule } from "@angular/core";
import { Routes, RouterModule, UrlSegment } from "@angular/router";
import { PrivacySettingsComponent } from "./privacy-settings.component";
import { ChangeLogsComponent } from "./change-logs/change-logs.component";

const EDITOR_PATHS = ["editPrivacy", "prepare-logs", "editLog"];

const routes: Routes = [
  { path: "privacy", component: PrivacySettingsComponent },
  {
    path: "change-logs",
    component: ChangeLogsComponent,
  },
  // editPrivacy/1, prepare-logs, editLog/:userId: loaded on demand (CKEditor)
  {
    matcher: (segments: UrlSegment[]) =>
      segments.length && EDITOR_PATHS.includes(segments[0].path) ? { consumed: [] } : null,
    loadChildren: () =>
      import("./privacy-editor/privacy-editor.module").then((m) => m.PrivacyEditorModule),
  },
  //     {

  //     path: "",
  //     component: PrivacySettingsComponent,
  //     children: [
  //       { path: "", redirectTo: "privacy", pathMatch: "full" },
  //       { path: "privacy", component: PrivacySettingsComponent },
  //       { path: "change-logs", component: ChangeLogsComponent },
  //     ],
  //   },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrivacySettingsRoutingModule {}
